import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';

export default class ButtonToTop extends Component {
  static propTypes = {

  };

  handleClick = () => window.scrollTo(0, 0);

  render() {
    return (
      <div className="common-button-to-top">
        <Button
          size='huge'
          // className="hamburguer-button"
          // content='Show'
          icon="arrow circle up"
          // labelPosition='right'
          onClick={this.handleClick}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/ButtonToTop.js